import React from 'react';
import {Link} from 'react-router-dom';
import firebase from 'firebase/app';
import 'firebase/auth';
import usePersistentStore from "../../persistentStore";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Container from "@material-ui/core/Container";
import CssBaseline from "@material-ui/core/CssBaseline";
import Typography from "@material-ui/core/Typography";
import {makeStyles} from "@material-ui/core/styles";
import * as STATES from "../../constants/states";
import {notify} from "../../utils/notify";

const useStyles = makeStyles(theme => ({
    paper: {
        marginTop: theme.spacing(4),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(0),
    },
    rememberMe: {
        marginTop: theme.spacing(0),
        fontSize: '100%',
        '& .MuiTypography-root, MuiButtonBase-root': {
            fontSize: '100%',
        },
    },
    submit: {
        margin: 0,
    },
    links: {
        marginTop: theme.spacing(1)
    },
    rightLink: {
        textAlign: 'right',
    }
}));

const PasswordReset = props => {
    const classes = useStyles();
    const [globalPersistentState, globalPersistentActions] = usePersistentStore();
    const isInvalid = (!globalPersistentState.me || globalPersistentState.me.email === '');

    const onSubmit = event => {
        firebase.auth().sendPasswordResetEmail(globalPersistentState.me.email)
            .then(() => {
                globalPersistentActions.setState(STATES.LOGGING_OUT);
            })
            .catch(error => {
                notify('sendPasswordResetEmail', 'error', error.message);
            });
        event.preventDefault();
    };

    const onChange = event => {
        // TODO medium - PasswordReset - something needs to happen here
    };

    return (
        <div>
            <Container component="main" maxWidth="xs">
                <CssBaseline/>
                <div className={classes.paper}>
                    <Typography component="h6" variant="h6" className={classes.sectionTitle}>
                        Reset Password
                    </Typography>
                </div>
                <div className={classes.paper}>
                    <form className={classes.form} onSubmit={onSubmit} noValidate>
                        <TextField
                            variant="outlined"
                            margin="dense"
                            required
                            fullWidth
                            id="email"
                            value={globalPersistentState.me.email}
                            onChange={onChange}
                            label="Email Address"
                            placeholder="Email Address"
                            name="email"
                            autoComplete="email"
                            autoFocus
                        />
                        <Button
                            id={"password-reset"}
                            type="submit"
                            fullWidth
                            disabled={isInvalid}
                            variant="contained"
                            color="primary"
                            className={classes.submit}
                        >
                            Reset My Password
                        </Button>
                        {globalPersistentState.me.error && <p>{globalPersistentState.me.error.message}</p>}
                    </form>

                </div>
            </Container>
        </div>
    )
};

export const PasswordResetLink = () => (
    <Link to={"/password-reset"} variant="body2">
        {"Forgot Password?"}
    </Link>
);

export default PasswordReset;
